import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import { ButtonMain } from '»components/atoms/Buttons';
import { TrlIconTextList } from '»components/atoms/TrlIconTextList';
import { usePageNavigation } from '»utils/customHooks';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import { onboardingSlice } from '../redux';
import { legalStatusSelector } from '../redux/onboarding.selectors';
import { InitialInfoContainer } from './OnboardingInitialInfo.styles';

export const OnboardingInitialInfo = () => {
  const dispatch = useDispatch();

  const legalStatus = useSelector(legalStatusSelector);

  const { navigateToPage } = usePageNavigation();

  const isNaturalPerson = legalStatus === 'PS';

  const documentsList = {
    PS: [
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-ID_DOCUMENT_AND_SUPP_DOC',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-PROOF_OF_ADDRESS',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-PROOF_OF_SOURCE_FUNDS',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({ id: 'TRLT_UI-PROOF_OF_BANK' }),
      },
    ],
    PC: [
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-COMPANY_BYLAWS',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-COMMERCIAL_REGISTRATION',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-TAX_IDENTIFICATION_NUM',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-COMMERCIAL_LICENSE',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-IDENTIF_DOC_REPRESENTATIVES',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-MODEL_1',
        }),
      },
      {
        icon: faCheck,
        primaryDescr: TrlFormattedMessagePlain({
          id: 'TRLT_UI-PROOF_OF_BANK',
        }),
      },
    ],
  };

  return (
    <InitialInfoContainer id="onboardingInitialInfoContainer">
      <TrlIconTextList list={documentsList[legalStatus]} />
      <ButtonMain
        expressionId={isNaturalPerson ? 'TRLT_UI-NEXT' : 'TRLT_UI-BACK'}
        onClick={() => {
          if (isNaturalPerson) {
            dispatch(
              onboardingSlice.actions.setOnboardingCurrentStep({
                direction: 'forward',
              }),
            );
          } else {
            navigateToPage({
              route: '/',
              menuItem: 'LANDING_PAGE',
              shouldResetAuth: true,
            });
          }
        }}
      />
    </InitialInfoContainer>
  );
};
